
import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  useMediaQuery,
} from "@mui/material";
import Email from "@mui/icons-material/Email";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {/* Header Section */}
      <AppBar position="static" sx={{ backgroundColor: "#000" }}>
        <Container>
          <Toolbar sx={{ justifyContent: "space-between", flexDirection: isMobile ? "column" : "row" }}>
            <Box display="flex" alignItems="center" sx={{ mb: isMobile ? 1 : 0 }}>
              <Email sx={{ mr: 1, color: "#fff" }} />
              <Typography variant="body1" color="inherit" textAlign={isMobile ? "center" : "left"}>
                Need help? Email Us Now : <strong><Link to="mailto:vamajewelslimited@gmail.com" style={{color:"white"}}>vamajewelslimited@gmail.com</Link></strong>
              </Typography>
            </Box>

            <Box>
              <a
                href="https://api.whatsapp.com/send?phone=919920897971"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success  mt-3 mb-3"
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                <i className="bi bi-whatsapp" style={{ marginRight: "5px" }}></i> Inquire on WhatsApp
              </a>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
}

export default Header;